import { atom } from "jotai";

export const skipWhyAdsButtonVisibleAtom = atom(false);
